import { useState } from "react";
import { x } from "@xstyled/styled-components";

import { SectionProps } from "../../common/types";

import { Clickable, Text } from "@otta/design";
import { Icon } from "@otta/icons";

export function JobHybridInfo({
  fields: { locationInformation, locationRestrictions },
}: SectionProps): React.ReactElement | null {
  const [show, setShow] = useState(false);

  if (!locationInformation.trim() && !locationRestrictions.trim()) {
    return null;
  }

  return show ? (
    <x.div display="flex" flexDirection="column" gap="sm">
      {!!locationInformation && <Text size={-1}>{locationInformation}</Text>}
      {!!locationRestrictions && (
        <x.span as={Text} size={-1} display="flex" gap="sm">
          <x.strong display="inline-flex" gap="xs">
            <Icon icon="circle-info" /> Restrictions:
          </x.strong>
          {locationRestrictions}
        </x.span>
      )}
    </x.div>
  ) : (
    <Clickable onClick={() => setShow(true)}>
      <x.span as={Text} display="flex" gap="sm">
        <span style={{ textDecoration: "underline" }}>
          More information about location
        </span>
        <Icon icon="chevron-down" />
      </x.span>
    </Clickable>
  );
}
